/* eslint-disable no-template-curly-in-string */
import $ from 'jquery';
import { debounceCancelable } from '../../util/system.js';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	const defaultOptions = {
		decrementButton: '<strong>&minus;</strong>', // button text
		incrementButton: '<strong>&plus;</strong>', // ..
		groupClass: '', // css class of the resulting input-group
		buttonsClass: 'btn-outline-secondary',
		buttonsWidth: '2.5rem',
		textAlign: 'center', // alignment of the entered number
		autoDelay: 500, // ms threshold before auto value change
		autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
		delayChange: 433, // delay the change event
		buttonsOnly: false, // set this `true` to disable the possibility to enter or paste the number via keyboard
		keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
		locale: 'en', // the locale, per default detected automatically from the browser
		template: // the template of the input
			'<div class="quantity-spinner ${groupClass}">' +
			'<button class="quantity-spinner__button quantity-spinner__button--decrement btn-decrement ${buttonsClass}" type="button">${decrementButton}</button>' +
			'<input type="text" inputmode="decimal" autocomplete="off" />' +
			'<button class="quantity-spinner__button quantity-spinner__button--decrement btn-increment ${buttonsClass}" type="button">${incrementButton}</button>' +
			'</div>',
	};

	// ======================================
	// Init input spinners
	// ======================================

	/** @type {JQuery<HTMLElement>} */
	const $inputSpinners = $container.find('input[data-quantity-spinner]');

	if ($inputSpinners.length > 0) {

		$inputSpinners.each((_, element) => {
			const $element = $(element);
			const data = $element.data('quantitySpinner');
			const options = (data && typeof data === 'object') ? data : {};

			$element.inputSpinner({ ...defaultOptions, ...options });
		});
	}

	// ======================================================================
	// Init spinners from div wrappers (that don't suffer from layout-shifts)
	// ======================================================================

	/** @type {JQuery<HTMLElement>} */
	const $divSpinners = $container.find('div[data-quantity-spinner-wrapper]');

	if ($divSpinners.length > 0) {

		// Only the input template
		const inputTemplate = '<input type="text" inputmode="decimal" autocomplete="off" />';

		$divSpinners.each((_, wrapper) => {
			const $wrapper = $(wrapper);
			const $input = $wrapper.find('input[data-input-spinner-input]');

			// No input found
			if ($input.length === 0) {
				console.warn('No input found form initializing the quantity spinner wrapper: %o', $wrapper);
				return;
			}

			const inputData = $input.data('input-spinner-input');
			const options = (inputData && typeof inputData === 'object') ? inputData : {};

			// New placeholder wrapper for customizations
			const $templatePlaceholder = $('<div />');
			const $inputPlaceholder = $('<section style="display:none;" />');

			// Insert a placeholder to remember the wrapper position
			$inputPlaceholder.insertAfter($wrapper);
			// Add the wrapper container the the placeholder
			$templatePlaceholder.append($wrapper);

			// Prepare template parts
			const $dummyInput = $(inputTemplate);
			$dummyInput.insertAfter($input);
			// Re-insert the input after the placeholder
			$input.insertAfter($inputPlaceholder);
			$inputPlaceholder.remove();

			// Prepare the buttons
			const $decrementButton = $templatePlaceholder.find('[data-input-spinner-decrement-button]').replaceWith('${decrementButton}');
			const $incrementButton = $templatePlaceholder.find('[data-input-spinner-increment-button]').replaceWith('${incrementButton}');

			// Set button options
			options.decrementButton = $('<div />').append($decrementButton).html();
			options.incrementButton = $('<div />').append($incrementButton).html();
			// Fix toggle_widgets_handler (data-change-handler) setting the 'disabled' class too early
			// Make sure not to send the disabled class to circumvent the bootstrap-input-spinner to set it back
			options.groupClass = $wrapper.attr('class').replaceAll(/\bdisabled\b/g, '');
			// These options are no longer needed
			options.buttonsClass = '';
			options.buttonsWidth = '';
			options.textAlign = '';

			// Set template option
			options.template = $templatePlaceholder.html();

			// const $row = $input.closest(mpro.config.ui.form_row_selector);

			// Fix toggle_widgets_handler (data-change-handler) setting the 'disabled' class too early
			// const observer = new MutationObserver((mutationList, _observer) => {
			// 	for (const mutation of mutationList) {
			// 		if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
			// 			/** @type {HTMLInputElement} */
			// 			// @ts-ignore
			// 			const target = mutation.target;
			// 			// debugger;
			// 			console.log('is disabled: %o', target.disabled);
			// 			// $row.children().not(target).not('input').toggleClass('disabled', target.disabled);
			// 		}
			// 	}
			// });
			// observer.observe($input[0], { attributes: true, attributeFilter: ['disabled'] });
			// $row.on('disable.bind-change-action-container', (e) => {
			// 	console.log('disable.bind-change-action-container: %o', $input.prop('disabled'));
			// });

			// Default browser locale
			if ('locale' in options && !options.locale) {
				options.locale = 'en';
			}

			// Init the spinner on the input
			new InputSpinner($input[0], { ...defaultOptions, ...options });
		});
	}
});
export default mpro;

// --------------------------------------

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

// the default editor for parsing and rendering
class I18nEditor {

	constructor(props, element) {
		this.locale = props.locale || 'en-US';
		this.element = element;
	}

	parse(customFormat) {
		const numberFormat = new Intl.NumberFormat(this.locale);
		const thousandSeparator = numberFormat.format(11_111).replaceAll('1', '') || '.';
		const decimalSeparator = numberFormat.format(1.1).replaceAll('1', '');
		return Number.parseFloat(customFormat
			.replaceAll(' ', '')
			.replaceAll(new RegExp('\\' + thousandSeparator, 'g'), '')
			.replace(new RegExp('\\' + decimalSeparator), '.'),
		);
	}

	render(number) {
		const decimals = Number.parseInt(this.element.dataset.decimals, 10) || 0;
		const digitGrouping = !(this.element.dataset.digitGrouping === 'false');
		const numberFormat = new Intl.NumberFormat(this.locale, {
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
			useGrouping: digitGrouping,
		});
		return numberFormat.format(number);
	}
}

let triggerKeyPressed = false;

// This is useless - to be removed in the future
// --------------------------------------------
const originalVal = $.fn.val;
$.fn.val = function(value) {
	if (arguments.length > 0) {
		for (let i = 0; i < this.length; i++) {
			if (this[i]['bootstrap-input-spinner'] && this[i].setValue) {
				const element = this[i];
				setTimeout(() => {
					element.setValue(value);
				});
			}
		}
	}
	return Reflect.apply(originalVal, this, arguments);
};
// --------------------------------------------

export class InputSpinner {

	constructor(element, props) {

		const self = this;
		this.element = element;
		/*
		if (props === "destroy") { // todo replace with method
				this.each(function () {
						if (this["bootstrap-input-spinner"]) {
								this.destroyInputSpinner()
						} else {
								console.warn("element", this, "is no bootstrap-input-spinner")
						}
				})
				return this
		}
		 */

		this.props = {
			decrementButton: '<strong>&minus;</strong>', // button text
			incrementButton: '<strong>&plus;</strong>', // ..
			groupClass: '', // css class of the resulting input-group
			buttonsClass: 'btn-outline-secondary',
			buttonsWidth: '2.5rem',
			textAlign: 'center', // alignment of the entered number
			autoDelay: 500, // ms threshold before auto value change
			autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
			delayChange: 433, // delay the change event
			buttonsOnly: false, // set this `true` to disable the possibility to enter or paste the number via keyboard
			keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
			locale: navigator.language, // the locale, per default detected automatically from the browser
			editor: I18nEditor, // the editor (parsing and rendering of the input)
			template: // the template of the input
				'<div class="input-group ${groupClass}">' +
				'<button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button>' +
				'<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/>' +
				'<button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button>' +
				'</div>',
		};

		Object.assign(this.props, props);

		const html = this.props.template
			.replaceAll('${groupClass}', this.props.groupClass)
			.replaceAll('${buttonsWidth}', this.props.buttonsWidth)
			.replaceAll('${buttonsClass}', this.props.buttonsClass)
			.replaceAll('${decrementButton}', this.props.decrementButton)
			.replaceAll('${incrementButton}', this.props.incrementButton)
			.replaceAll('${textAlign}', this.props.textAlign);

		if (this.element['bootstrap-input-spinner']) {
			console.warn('element', this.element, 'is already a bootstrap-input-spinner');
		}
		else {

			const delayChange = (('delayChange' in this.element.dataset) ? Number(this.element.dataset.delayChange) : Number(this.props.delayChange)) || 0;
			const [debouncedChangeEvent, cancelChangeEvent] = (delayChange > 0)
				? debounceCancelable(($element) => {
					dispatchEvent($element, 'change');
				}, delayChange)
				: [($element) => {
					dispatchEvent($element, 'change');
				}, () => {}];

			this.$original = $(this.element);
			this.$original[0]['bootstrap-input-spinner'] = true;
			this.$original.hide();
			this.$original[0].inputSpinnerEditor = new this.props.editor(this.props, this.element);

			this.autoDelayHandler = null;
			this.autoIntervalHandler = null;

			this.$inputGroup = $(html);
			this.$buttonDecrement = this.$inputGroup.find('.btn-decrement');
			this.$buttonIncrement = this.$inputGroup.find('.btn-increment');
			this.$input = this.$inputGroup.find('input');
			this.$label = $('label[for=\'' + this.$original.attr('id') + '\']');
			if (!this.$label[0]) {
				this.$label = this.$original.closest('label');
			}

			this.min = null;
			this.max = null;
			this.step = null;
			this.decimals = null;

			updateAttributes();

			this.value = Number.parseFloat(this.$original[0].value);
			let pointerState = false;

			const prefix = this.$original.attr('data-prefix') || '';
			const suffix = this.$original.attr('data-suffix') || '';

			if (prefix) {
				const prefixElement = $('<span class="input-group-text">' + prefix + '</span>');
				this.$inputGroup.find('input').before(prefixElement);
			}
			if (suffix) {
				const suffixElement = $('<span class="input-group-text">' + suffix + '</span>');
				this.$inputGroup.find('input').after(suffixElement);
			}

			this.$original[0].setValue = function(newValue) {
				setValue(newValue);
			};
			this.$original[0].destroyInputSpinner = function() {
				destroy();
			};

			this.observer = new MutationObserver(() => {
				updateAttributes();
				setValue(self.value, true);
			});
			this.observer.observe(this.$original[0], { attributes: true });

			this.$original.after(this.$inputGroup);

			setValue(this.value);

			this.$input.on('paste input change focusout', (event) => {
				let newValue = self.$input[0].value;
				const focusOut = event.type === 'focusout';
				if (!self.props.buttonsOnly) {
					// Safely parse a string into a float
					const safeParseFloat = (str) => {
						let num = parseFloat(str);
						return isNaN(num) ? self.step : num;
					};

					newValue = safeParseFloat(self.$original[0].inputSpinnerEditor.parse(newValue));

					// Use the step when calculating the new value
					// if (event.type === 'paste' || focusOut) {
						if (newValue % self.step > 0.001) {
							newValue = Math.ceil(newValue / self.step) * self.step;
						}
					// }

					newValue = newValue.toFixed(self.decimals);

					setValue(newValue, focusOut);
					if (event.type === 'change') {
						debouncedChangeEvent(self.$original);
					}
					else {
						dispatchEvent(self.$original, event.type);
					}
				}
				if (self.props.keyboardStepping && focusOut) { // stop stepping
					resetTimer();
				}
			}).on('keydown', (event) => {
				if (self.props.keyboardStepping) {
					if (event.which === 38) { // up arrow pressed
						event.preventDefault();
						if (!self.$buttonDecrement.prop('disabled')) {
							stepHandling(self.step);
							debouncedChangeEvent(self.$original);
						}
					}
					else if (event.which === 40) { // down arrow pressed
						event.preventDefault();
						if (!self.$buttonIncrement.prop('disabled')) {
							stepHandling(-self.step);
							debouncedChangeEvent(self.$original);
						}
					}
				}
			}).on('keyup', (event) => {
				// up/down arrow released
				if (self.props.keyboardStepping && (event.which === 38 || event.which === 40)) {
					event.preventDefault();
					resetTimer();
				}
			});

			// decrement button
			onPointerDown(self.$buttonDecrement[0], () => {
				if (!self.$buttonDecrement.prop('disabled')) {
					pointerState = true;
					stepHandling(-self.step);
					cancelChangeEvent();
				}
			});
			// increment button
			onPointerDown(self.$buttonIncrement[0], () => {
				if (!self.$buttonIncrement.prop('disabled')) {
					pointerState = true;
					stepHandling(self.step);
					cancelChangeEvent();
				}
			});
			onPointerUp(document.body, () => {
				if (pointerState === true) {
					resetTimer();
					debouncedChangeEvent(self.$original);
					pointerState = false;
				}
			});
		}

		function setValue(newValue, updateInput) {
			if (updateInput === undefined) {
				updateInput = true;
			}
			if (isNaN(newValue) || newValue === '') {
				self.$original[0].value = '';
				if (updateInput) {
					self.$input[0].value = '';
				}
				self.value = Number.NaN;
			}
			else {
				newValue = Number.parseFloat(newValue);
				newValue = Math.min(Math.max(newValue, self.min), self.max);
				self.$original[0].value = newValue;
				if (updateInput) {
					self.$input[0].value = self.$original[0].inputSpinnerEditor.render(newValue);
				}
				self.value = newValue;
			}
		}

		function destroy() {
			self.$original.prop('required', self.$input.prop('required'));
			self.observer.disconnect();
			resetTimer();
			self.$input.off('paste input change focusout');
			self.$inputGroup.remove();
			self.$original.show();
			self.$original[0]['bootstrap-input-spinner'] = undefined;
			if (self.$label[0]) {
				self.$label.attr('for', self.$original.attr('id'));
			}
		}

		function dispatchEvent($element, type, delay = 0) {
			if (type) {
				setTimeout(() => {
					const event = new Event(type, { bubbles: true });
					$element[0].dispatchEvent(event);
				});
			}
		}

		function stepHandling(step) {
			calcStep(step);
			resetTimer();
			if (self.props.autoInterval !== undefined) {
				self.autoDelayHandler = setTimeout(() => {
					self.autoIntervalHandler = setInterval(() => {
						calcStep(step);
					}, self.props.autoInterval);
				}, self.props.autoDelay);
			}
		}

		function calcStep(step) {
			if (isNaN(self.value)) {
				self.value = 0;
			}
			setValue((Math.round(self.value / step) * step + step).toFixed(self.decimals));
			dispatchEvent(self.$original, 'input');
		}

		function resetTimer() {
			clearTimeout(self.autoDelayHandler);
			clearTimeout(self.autoIntervalHandler);
		}

		function updateAttributes() {
			// copy properties from original to the new input
			if (self.$original.prop('required')) {
				self.$input.prop('required', self.$original.prop('required'));
				self.$original.removeAttr('required');
			}
			self.$input.prop('placeholder', self.$original.prop('placeholder'));
			self.$input.attr('inputmode', self.$original.attr('inputmode') || 'decimal');
			const disabled = self.$original.prop('disabled');
			const readonly = self.$original.prop('readonly');
			self.$input.prop('disabled', disabled);
			self.$input.prop('readonly', readonly || self.props.buttonsOnly);
			self.$buttonIncrement.prop('disabled', disabled || readonly);
			self.$buttonDecrement.prop('disabled', disabled || readonly);
			if (disabled || readonly) {
				resetTimer();
			}
			const originalClass = self.$original.prop('class');
			let groupClass = '';
			// sizing
			if (/form-control-sm/g.test(originalClass)) {
				groupClass = 'input-group-sm';
			}
			else if (/form-control-lg/g.test(originalClass)) {
				groupClass = 'input-group-lg';
			}
			const inputClass = originalClass.replaceAll(/form-control(-(sm|lg))?/g, '');
			self.$inputGroup.prop('class', 'input-group ' + groupClass + ' ' + self.props.groupClass);
			self.$input.prop('class', 'form-control ' + inputClass);

			// update the main attributes
			self.min = isNaN(self.$original.prop('min')) || self.$original.prop('min') === '' ? Number.NEGATIVE_INFINITY : Number.parseFloat(self.$original.prop('min'));
			self.max = isNaN(self.$original.prop('max')) || self.$original.prop('max') === '' ? Number.POSITIVE_INFINITY : Number.parseFloat(self.$original.prop('max'));
			self.step = Number.parseFloat(self.$original.prop('step')) || 1;
			self.decimals = Number.parseInt(self.$original.data('decimals')) || 0;
			if (self.$original.attr('hidden')) {
				self.$inputGroup.attr('hidden', self.$original.attr('hidden'));
			}
			else {
				self.$inputGroup.removeAttr('hidden');
			}
			if (self.$original.attr('id')) {
				self.$input.attr('id', self.$original.attr('id') + ':input_spinner'); // give the spinner a unique id...
				if (self.$label[0]) {
					self.$label.attr('for', self.$input.attr('id')); // ...to rewire the label
				}
			}
		}

		// TODO: refactor with proper memory-safe event handling
		function onPointerUp(element, callback) {
			element.addEventListener('mouseup', (e) => {
				callback(e);
			});
			element.addEventListener('touchend', (e) => {
				callback(e);
			});
			element.addEventListener('keyup', (e) => {
				if ((e.keyCode === 32 || e.keyCode === 13)) {
					triggerKeyPressed = false;
					callback(e);
				}
			});
		}

		// TODO: refactor with proper memory-safe event handling
		function onPointerDown(element, callback) {
			element.addEventListener('mousedown', (e) => {
				if (e.button === 0) {
					e.preventDefault();
					callback(e);
				}
			});
			element.addEventListener('touchstart', (e) => {
				if (e.cancelable) {
					e.preventDefault();
				}
				callback(e);
			}, { passive: false });
			element.addEventListener('keydown', (e) => {
				if ((e.keyCode === 32 || e.keyCode === 13) && !triggerKeyPressed) {
					triggerKeyPressed = true;
					callback(e);
				}
			});
		}
	}

}

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */
const customEditors = {
	RawEditor(props, element) {
		this.parse = function(customFormat) {
			// parse nothing
			return customFormat;
		};
		this.render = function(number) {
			// render raw
			return number;
		};
	},
	TimeEditor(props, element) {
		// could be implemented more elegant maybe, but works
		this.parse = function(customFormat) {
			let trimmed = customFormat.trim();
			let sign = 1;
			if (trimmed.charAt(0) === '-') {
				sign = -1;
				trimmed = trimmed.replace('-', '');
			}
			const parts = trimmed.split(':');
			let hours = 0; let minutes;
			if (parts[1]) {
				hours = Number.parseInt(parts[0], 10);
				minutes = Number.parseInt(parts[1], 10);
			}
			else {
				minutes = Number.parseInt(parts[0], 10);
			}
			return (hours * 60 + minutes) * sign;
		};
		this.render = function(number) {
			let minutes = Math.abs(number % 60);
			if (minutes < 10) {
				minutes = '0' + minutes;
			}
			let hours;
			if (number >= 0) {
				hours = Math.floor(number / 60);
				return hours + ':' + minutes;
			}
			hours = Math.ceil(number / 60);
			return '-' + Math.abs(hours) + ':' + minutes;

		};
	},
};